<template>
    <v-footer flat>
        <v-container>
            <v-row class="mx-2 d-flex justify-center">
                <v-col class="col-sm-6 col-md-4 col-lg-2 col-xl-2 col-12">
                    <h3 class="mb-1">Location</h3>
                    <div>
                        <v-img max-height="150" max-width="250" @click="goToMap" :src="GetPropertyInfo().mapUrl"></v-img>
                    </div>
                </v-col>
                <v-col class="col-sm-6 col-md-4 col-lg-2 col-xl-2 col-12">
                    <h3 class="mb-1">Property policies</h3>
                    <div class="my-1">
                        Check-in:
                    </div>
                    <div class="my-1">
                        Check-out:
                    </div>
                    <div class="my-1">
                        <a href="#" class="text-decoration-none footer-link-hover">Terms and Conditions</a>
                    </div>
                    <div class="my-1">
                        <a href="#" class="text-decoration-none footer-link-hover">Cancellation Policy</a>
                    </div>
                </v-col>
                <v-col class="col-sm-6 col-md-4 col-lg-2 col-xl-2 col-12">
                    <h3 class="mb-1">Facilities</h3>
                    <div>
                    </div>
                </v-col>
                <v-col class="col-sm-6 col-md-4 col-lg-2 col-xl-2 col-12">
                    <h3 class="mb-1">Services & Others</h3>
                </v-col>


            </v-row>
        </v-container>
    </v-footer>

</template>

<script>
import { mapGetters } from "vuex";

export default {
    data() {
        return {
            icons: [
                'mdi-facebook',
                'mdi-youtube',
                'mdi-instagram',
            ],
        }
    },
    computed: {
        ...mapGetters([
            'GetBookingPolicy',
            'GetPropertyInfo',
            'GetPropertyFacilitiesAndServices']),
            facilities: function(){
                return this.GetPropertyFacilitiesAndServices().filter(f => f.categoryId == 'Feature')
            },
            services: function(){
                return this.GetPropertyFacilitiesAndServices().filter(f => f.categoryId == 'Service')
            }
    },
    methods: {
        goToMap: function () {
            window.open(this.GetPropertyInfo().mapLocation, '_blank').focus();
        }
    }
}
</script>